declare global {
  interface Window {
    gtag: (...args: any[]) => void;
    fbq: (...args: any[]) => void;
  }
}

function gtag(...args: any[]) {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag(...args);
  }
}

function fbq(...args: any[]) {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq(...args);
  }
}

export function trackAddToCart(itemName: string, priceCents: number, currency = 'USD') {
  const value = priceCents / 100;

  gtag('event', 'add_to_cart', {
    currency,
    value,
    items: [{ item_name: itemName, price: value, quantity: 1 }],
  });

  fbq('track', 'AddToCart', {
    content_name: itemName,
    content_type: 'product',
    value,
    currency,
  });
}

export function trackInitiateCheckout(itemName: string, priceCents: number, currency = 'USD') {
  const value = priceCents / 100;

  gtag('event', 'begin_checkout', {
    currency,
    value,
    items: [{ item_name: itemName, price: value, quantity: 1 }],
  });

  fbq('track', 'InitiateCheckout', {
    content_name: itemName,
    content_type: 'product',
    value,
    currency,
    num_items: 1,
  });
}

export function trackPurchase(itemName: string, priceCents: number, currency = 'USD', transactionId?: string) {
  const value = priceCents / 100;

  gtag('event', 'purchase', {
    currency,
    value,
    transaction_id: transactionId || `txn_${Date.now()}`,
    items: [{ item_name: itemName, price: value, quantity: 1 }],
  });

  fbq('track', 'Purchase', {
    content_name: itemName,
    content_type: 'product',
    value,
    currency,
    num_items: 1,
  });
}

export function trackCustomEvent(eventName: string, params?: Record<string, any>) {
  gtag('event', eventName, params);
  fbq('trackCustom', eventName, params);
}
